<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>To all professing Christians out there who want to enjoy reading the Bible and telling it to others with simplicity, clarity and boldness, may God use this book as a launching pad for you to see the beauty of the gospel of Jesus Christ and for your heart to be captured by it. My prayer is for you, after reading this book, to sing in the same tune as Apostle Paul who wrote, “Indeed, I count everything as loss because of the surpassing worth of knowing Christ Jesus—my Lord. For his sake, I have suffered the loss of all things and count them as rubbish, in order that I may gain Christ.” (Philippians 3:8)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?3024c60f